import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Form, Button, Modal } from "react-bootstrap";
import axios from "axios";
import { environment } from "../../environment.js";
import { LinkContainer } from "react-router-bootstrap";
import Loader from "../Components/Loader.js";
import Select from "react-select";
import Toggle from "react-toggle";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import Dropdown from "react-bootstrap/Dropdown";
import { fontSize } from "@mui/system";
import NavbarNew from "../Components/NavbarNew.js";
const MySwal = withReactContent(Swal);

const QuestionIndex = () => {
  const [questions, setQuestions] = useState([]);
  const [question_details, setQuestionDetail] = useState({});
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
  };
  useEffect((e) => {
    axios
      .get(environment.dap_url + "questionnarieApi/getAllQuestions?team=Sales")
      .then((res) => {
        setQuestions(res.data);
      })
      .catch(function (error) {
        console.log(error);
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  }, []);
  const getquestion = (_id) => {
    axios
      .get(environment.dap_url + "questionnarieApi/getQuestionByid?id=" + _id)
      .then((res) => {
        // console.log("abcdef", res.data[0].question);
        setQuestionDetail(res.data);
        handleShow();
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  };
  const columns = [
    {
      dataField: "sl.no",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
      sort: true,
    },
    {
      dataField: "question",
      text: "Question",
      sort: true,
    },
    {
      dataField: "questionType",
      text: "Question Type",
      sort: true,
    },
    {
      dataField: "questionMasterId",
      text: "Feedback Question Type",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        if (questions[rowIndex].questionMasterId == 1)
          return "Customer Feedback";
        else if (questions[rowIndex].questionMasterId == 2)
          return "Volunatry Feedback";
        else {
          return "After Usage Feedback";
        }
      },
    },
    {
      dataField: "_id",
      text: "Action",
      sort: false,
      formatter: (dataField) => {
        return (
          <div>
            <Button
              variant="primary"
              className="btn-sm"
              onClick={() => getquestion(dataField)}
            >
              <i className="fa fa-eye"></i>
            </Button>
          </div>
        );
      },
    },
  ];
  return (
    <div class="container-fluid">
      <NavbarNew />
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Question</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table class="table table-bordered">
            <tbody>
              <tr>
                {/* <th width="50%" scope="row">
                    Question
                  </th> */}
                <td style={{ fontSize: "15px" }}>
                  Q. {question_details[0] && question_details[0].question}
                </td>
              </tr>
              <tr>
                <td>
                  <ul>
                    {question_details[0] &&
                      question_details[0].answerOptions.map((option, index) => (
                        <li key={index}>
                          {option.option} - {option.waitage}
                        </li>
                      ))}
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="row" style={{ marginTop: "2%", padding: "10px" }}>
        <div className="col-lg-6">
          {/* <Link to="/customers" className="btn btn-light my-3">
              Go Back
            </Link> */}
        </div>
      </div>

      <div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">QUESTIONS</h4>
                <div className="row">
                  <div className="col-12">
                    <ToolkitProvider
                      keyField="id"
                      bootstrap4
                      data={questions}
                      columns={columns}
                      search
                    >
                      {(props) => (
                        <div>
                          <div className="d-flex align-items-center">
                            <p className="mb-2 mr-2">Search in table:</p>
                            {/* <SearchBar {...props.searchProps} /> */}
                          </div>
                          <BootstrapTable
                            pagination={paginationFactory()}
                            {...props.baseProps}
                            wrapperClasses="table-responsiv"
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default QuestionIndex;
